import {
  Dashboard,
  ManageRegion,
  ManageOutlet,
  ManageProduct,
  ManageTarget,
  ManagePlans,
  ScaleManagement,
  Notifications,
  UploadFile,
  StaffPer,
  AddNotifications,
  Offers,
  UserNoti,
  TrainingLearning,
  StaffPerNew,
} from "pages";
import MyPerformance from "pages/staffPerformanceNew/myPerformance";
import { NOTIFICATION_CATEGORIES } from "constant/variables";
import SystemUsageReport from "pages/systemUsageReport";
import QuizSurvey from "pages/quizSurvey/index.jsx";
import CreateQuiz from "../pages/createQuiz/index.jsx";
import TakeSurveyPage from "../pages/TakeSurvey/TakeSurveyPage.jsx";
import CreateSurvey from "../pages/createSurvey/index.jsx";
import ResultPage from "components/Result/ResultPage.jsx";
import InsightPage from "components/Insight/InsightPage.jsx";
import TrainingReport from "pages/TrainingReport/TrainingReport.jsx";
import CVM from "pages/CVM/CVM.jsx";

export const USER_NOTIFICATION_ROUTES = {
  [NOTIFICATION_CATEGORIES.OFFER]: "offers",
  [NOTIFICATION_CATEGORIES.NOTIFICATION]: "user-notifications",
  [NOTIFICATION_CATEGORIES.TRAINING]: "training-learning",
  [NOTIFICATION_CATEGORIES.QUIZ]: "quiz-survey",
  [NOTIFICATION_CATEGORIES.TRAINING_REPORT]: "training-report",
};

export const routes = [
  // { path: `${process.env.PUBLIC_URL}/`, Component: Dashboard },
  { path: `${process.env.PUBLIC_URL}/`, Component: MyPerformance },
  { path: `${process.env.PUBLIC_URL}/manageregion`, Component: ManageRegion },
  { path: `${process.env.PUBLIC_URL}/manageoutlet`, Component: ManageOutlet },
  { path: `${process.env.PUBLIC_URL}/manageproduct`, Component: ManageProduct },
  { path: `${process.env.PUBLIC_URL}/managetarget`, Component: ManageTarget },
  { path: `${process.env.PUBLIC_URL}/manageplans`, Component: ManagePlans },
  {
    path: `${process.env.PUBLIC_URL}/scalemanagement`,
    Component: ScaleManagement,
  },
  { path: `${process.env.PUBLIC_URL}/notifications`, Component: Notifications },
  {
    path: `${process.env.PUBLIC_URL}/notifications/add`,
    Component: AddNotifications,
  },
  {
    path: `${process.env.PUBLIC_URL}/notifications/add/:id`,
    Component: AddNotifications,
  },
  {
    path: `${process.env.PUBLIC_URL}/${
      USER_NOTIFICATION_ROUTES[NOTIFICATION_CATEGORIES.OFFER]
    }`,
    Component: Offers,
  },
  {
    path: `${process.env.PUBLIC_URL}/${
      USER_NOTIFICATION_ROUTES[NOTIFICATION_CATEGORIES.NOTIFICATION]
    }`,
    Component: UserNoti,
  },
  {
    path: `${process.env.PUBLIC_URL}/${
      USER_NOTIFICATION_ROUTES[NOTIFICATION_CATEGORIES.TRAINING]
    }`,
    Component: TrainingLearning,
  },
  {
    path: `${process.env.PUBLIC_URL}/${
      USER_NOTIFICATION_ROUTES[NOTIFICATION_CATEGORIES.TRAINING_REPORT]
    }`,
    Component: TrainingReport,
  },
  { path: `${process.env.PUBLIC_URL}/importSales`, Component: UploadFile },
  {
    path: `${process.env.PUBLIC_URL}/staffPerformance`,
    Component: StaffPerNew,
  },
  { path: `${process.env.PUBLIC_URL}/myPerformance`, Component: MyPerformance },
  { path: `${process.env.PUBLIC_URL}/cvm`, Component: CVM },

  {
    path: `${process.env.PUBLIC_URL}/system-usage-report`,
    Component: SystemUsageReport,
  },
  {
    path: `${process.env.PUBLIC_URL}/quiz-survey`,
    Component: QuizSurvey,
  },
  {
    path: `${process.env.PUBLIC_URL}/create-quiz`,
    Component: CreateQuiz,
  },
  {
    path: `${process.env.PUBLIC_URL}/create-survey`,
    Component: CreateSurvey,
  },
  {
    path: `${process.env.PUBLIC_URL}/take/:id`,
    Component: TakeSurveyPage,
  },
  {
    path: `${process.env.PUBLIC_URL}/result/:id/:type`,
    Component: ResultPage,
  },
  {
    path: `${process.env.PUBLIC_URL}/insight/:id/:type`,
    Component: InsightPage,
  },
  // { path: `${process.env.PUBLIC_URL}/profile`, Component: Profile },
  // { path: `${process.env.PUBLIC_URL}/marks-grades`, Component: MarksGrades },
  // {
  //   path: `${process.env.PUBLIC_URL}/eligible-programs`,
  //   Component: EligiblePrograms,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/choose-programs`,
  //   Component: ChoosePrograms,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/view-accept-offers`,
  //   Component: ViewAcceptOffers,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/file-upload`,
  //   Component: FileUpload,
  // },
];
